<template>
  <b-row>
    <b-col sm="5" class="form-label">
      <i :class="[icon, 'fax']"></i>
      <label>{{people.length}} <template v-if="people.length === 1">{{label}}</template><template v-else>{{labelPlural}}</template></label>
    </b-col>
    <b-col sm="6">
      <p class="text">
      <slot></slot>
      </p>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    labelPlural: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'fas fa-child'
    },
    people: {
      type: Array,
      default: []
    },
  }
}
</script>
<style>
.text {
  margin: 0;
  height: 100%;
  line-height: 40px;
}
</style>